import { c as _c } from "react/compiler-runtime";
import React from "react";
interface MemesLeaderboardDropHeaderProps {
  readonly title: string;
}
const MemesLeaderboardDropHeader: React.FC<MemesLeaderboardDropHeaderProps> = t0 => {
  const $ = _c(2);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className="tw-text-lg tw-font-bold tw-text-white tw-mb-0 tw-leading-tight">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default MemesLeaderboardDropHeader;